import React, { useState, useContext, useEffect } from "react";
import { BsCalendarMinusFill, BsChevronDown, BsChevronUp } from "react-icons/bs";
import { AiOutlineCheck, AiOutlineWarning, AiOutlineReload } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import ApiService from "../../../../ApiService";
import { getIsoToMediumFormatDatetime } from "../../../../util/common";
import { Button } from "react-bootstrap";
import { PAGES } from "../../../SuperAdminPanel/Dashboard";
import { SnackbarContext } from "../../../AlertSystem";

export default function SingleKit({ kitStatus, kitId, isClinicalRequired, dateOfRegistration, kitDetails, isSuperAdmin }) {
  const navigate = useHistory();
  const [isExpanded, setIsExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resultData, setResultData] = useState(null);
  const { showSnackbar } = useContext(SnackbarContext);

  const onClickChervonDown = async () => {
    try {
      setIsExpanded(true);
      setLoading(true);
      const response = await ApiService.getTestResultByKitId(kitId);
      if (response.data) {
        setResultData(response.data);
      }
      setLoading(false);
    } catch (error) {
      showSnackbar({ message: "Error fetching kit details.", severity: "error" });
      setLoading(false);
    }
  };

  const orderNewKit = async () => {
    try {
      const patientId = kitDetails?.patientId || kitDetails?.patient?.id || "";
      const productName = kitDetails?.productName || kitDetails?.product?.name || "";
      const goToPage = productName?.toLowerCase()?.includes("prep") ? PAGES.CREATE_PREP_ORDER : PAGES.CREATE_ORDER;
      const url = `/super-admin?page=${goToPage}&patientId=${patientId}&kitName=${productName}`;
      window.open(url, "_blank");
    } catch (error) {
      showSnackbar({ message: "Error reordering kit. Please try again later.", severity: "error" });
    }
  };

  return (
    <div className={`kitContent ${isExpanded ? "expanded" : ""}`}>
      <div>
        <p>Status</p>
        <h5>{kitStatus}</h5>
      </div>
      <div>
        <p>Kit ID</p>
        <h5>{kitId}</h5>
        {/* <p>Sub -3M</p> */}
      </div>
      <div className="borderContent-kit">
        <p>clinician</p>
        {isClinicalRequired ? (
          <h5>
            <span>
              <AiOutlineWarning color="red" />
            </span>{" "}
            clinician Required
          </h5>
        ) : (
          <h5>
            <span>
              <AiOutlineCheck color="green" />
            </span>{" "}
            {kitDetails?.clinician?.firstName} {kitDetails?.clinician?.lastName}
          </h5>
        )}
      </div>
      <div>
        <p>Date of Registration</p>
        <h5>{dateOfRegistration}</h5>
      </div>

      <button
        className="viewDetailsBtn"
        onClick={() => {
          const url = `/KitDetails?kitId=${kitId}`;

          const newState = {
            kitDetails: {
              ...kitDetails,
              user: kitDetails?.patient
            }
          };

          // Open the link in a new tab with state object
          const newTab = window.open(url, "_blank");
          if (newTab) {
            newTab.opener = null;
            newTab.location = url; // Set the location to the desired URL
            newTab.postMessage(newState, window.origin); // Send state object to the new tab
          }
        }}
      >
        <BsCalendarMinusFill />
        <span>View Kit Page</span>
      </button>
      {isSuperAdmin && (
        <Button
          style={{ marginLeft: "1rem", display: "flex", alignItems: "center", backgroundColor: "#ffffff", color: "#007F61" }}
          onClick={orderNewKit}
        >
          <AiOutlineReload />
          &nbsp;&nbsp;Reorder
        </Button>
      )}
      <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end" }}>
        {isExpanded ? (
          <BsChevronUp
            style={{
              fontSize: "1.5rem",
              color: "#000",
              cursor: "pointer"
            }}
            onClick={() => setIsExpanded(false)}
          />
        ) : (
          <BsChevronDown
            style={{
              fontSize: "1.5rem",
              color: "#000",
              cursor: "pointer"
            }}
            onClick={onClickChervonDown}
          />
        )}
      </div>
      {loading ? (
        <div
          class="skeleton-loading"
          style={{
            gridColumn: "1 / span 2"
          }}
        >
          <div class="skeleton-shimmer"></div>
        </div>
      ) : (
        <div className={`${resultData ? "resultData" : "gridSpanFullCol"}`}>
          <div className="resultData">
            {resultData ? (
              <div className="resultContainer">
                <p>Results</p>
                {resultData?.results.map((result, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between"
                      }}
                    >
                      <h6>{result?.testName}</h6>
                      <h6>{result?.result}</h6>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div
                style={{
                  gridColumn: "1 / span 7",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <h1 className="noRecordFound">No Result Found</h1>
              </div>
            )}
          </div>
        </div>
      )}
      {loading ? (
        <div class="skeleton-loading">
          <div class="skeleton-shimmer"></div>
        </div>
      ) : (
        resultData && (
          <div>
            <p>Product Name</p>
            <h5>{resultData?.productName}</h5>
          </div>
        )
      )}
      {loading ? (
        <div class="skeleton-loading">
          <div class="skeleton-shimmer"></div>
        </div>
      ) : (
        resultData && (
          <div>
            <p>Lab Date</p>
            <h5>{getIsoToMediumFormatDatetime(resultData?.createDateTime)}</h5>
          </div>
        )
      )}
    </div>
  );
}
